<mat-accordion multi class="expand-collapse-panel">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
    <form autocomplete="off" [formGroup]="form" id="filterOtherAsset" class="filter-form">
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>Unit Id</mat-label>
          <input placeholder="Unit Id"
            matInput
            [matChipInputFor]="chipUnitId"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event, 'unitids')">
          </mat-form-field>
          <mat-chip-grid #chipUnitId>
            @for (item of unitIds; track item) {
              <mat-chip-row
                [removable]="removable" (removed)="remove(item, 'unitids')">
                {{item}}
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
        </div>
        <div class="filter-field">
          <mat-form-field class="search-input">
            <mat-label>Branch Number</mat-label>
            <input placeholder="Branch Number"
              matInput
              [matChipInputFor]="chipBranchNumbers"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="applyFilter($event, 'branchnumbers')">
            </mat-form-field>
            <mat-chip-grid #chipBranchNumbers>
              @for (item of branchNumbers; track item) {
                <mat-chip-row
                  [removable]="removable" (removed)="remove(item, 'branchnumbers')">
                  {{item}}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
          </div>
          <div class="filter-field">
            <mat-form-field class="search-input">
              <mat-label>Controller Type</mat-label>
              <input placeholder="Controller Type"
                matInput
                [matChipInputFor]="chipControllerTypes"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="applyFilter($event, 'controllertypes')">
              </mat-form-field>
              <mat-chip-grid #chipControllerTypes>
                @for (item of controllerTypes; track item) {
                  <mat-chip-row
                    [removable]="removable" (removed)="remove(item, 'controllertypes')">
                    {{item}}
                    @if (removable) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip-row>
                }
              </mat-chip-grid>
            </div>
            <div class="filter-field">
              <mat-form-field class="search-input">
                <mat-label>Building Addr1</mat-label>
                <input placeholder="Building Addr1"
                  matInput
                  [matChipInputFor]="chipBuildingAddr1"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="applyFilter($event, 'buildingaddr1')">
                </mat-form-field>
                <mat-chip-grid #chipBuildingAddr1>
                  @for (item of buildingAddr1; track item) {
                    <mat-chip-row
                      [removable]="removable" (removed)="remove(item, 'buildingaddr1')">
                      {{item}}
                      @if (removable) {
                        <mat-icon matChipRemove>cancel</mat-icon>
                      }
                    </mat-chip-row>
                  }
                </mat-chip-grid>
              </div>
              <div class="filter-field">
                <mat-form-field class="search-input">
                  <mat-label>Building City</mat-label>
                  <input placeholder="Building City"
                    matInput
                    [matChipInputFor]="chipBuildingCities"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="applyFilter($event, 'buildingcities')">
                  </mat-form-field>
                  <mat-chip-grid #chipBuildingCities>
                    @for (item of buildingCities; track item) {
                      <mat-chip-row
                        [removable]="removable" (removed)="remove(item, 'buildingcities')">
                        {{item}}
                        @if (removable) {
                          <mat-icon matChipRemove>cancel</mat-icon>
                        }
                      </mat-chip-row>
                    }
                  </mat-chip-grid>
                </div>
                <div class="filter-field">
                  <mat-form-field class="search-input">
                    <mat-label>Nickname</mat-label>
                    <input placeholder="Nickname"
                      matInput
                      [matChipInputFor]="chipNicknames"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="addOnBlur"
                      (matChipInputTokenEnd)="applyFilter($event, 'nicknames')">
                    </mat-form-field>
                    <mat-chip-grid #chipNicknames>
                      @for (item of nicknames; track item) {
                        <mat-chip-row
                          [removable]="removable" (removed)="remove(item, 'nicknames')">
                          {{item}}
                          @if (removable) {
                            <mat-icon matChipRemove>cancel</mat-icon>
                          }
                        </mat-chip-row>
                      }
                    </mat-chip-grid>
                  </div>
                  <div class="filter-field">
                    <mat-form-field class="search-input">
                      <mat-label>Asset Type</mat-label>
                      <input placeholder="Asset Type"
                        matInput
                        [matChipInputFor]="chipAssetType"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur"
                        (matChipInputTokenEnd)="applyFilter($event, 'assettypes')">
                      </mat-form-field>
                      <mat-chip-grid #chipAssetType>
                        @for (item of assetTypes; track item) {
                          <mat-chip-row
                            [removable]="removable" (removed)="remove(item, 'assettypes')">
                            {{item}}
                            @if (removable) {
                              <mat-icon matChipRemove>cancel</mat-icon>
                            }
                          </mat-chip-row>
                        }
                      </mat-chip-grid>
                    </div>
                    <div class="filter-field">
                      <mat-form-field class="search-input">
                        <mat-label>Unit Type</mat-label>
                        <input placeholder="Unit Type"
                          matInput
                          [matChipInputFor]="chipUnitTypes"
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          [matChipInputAddOnBlur]="addOnBlur"
                          (matChipInputTokenEnd)="applyFilter($event, 'unitypes')">
                        </mat-form-field>
                        <mat-chip-grid #chipUnitTypes>
                          @for (item of unitTypes; track item) {
                            <mat-chip-row
                              [removable]="removable" (removed)="remove(item, 'unitypes')">
                              {{item}}
                              @if (removable) {
                                <mat-icon matChipRemove>cancel</mat-icon>
                              }
                            </mat-chip-row>
                          }
                        </mat-chip-grid>
                      </div>
                      <div class="filter-actions">
                        <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
                          {{ changeTypeButton() ? 'Reset' : 'Filter' }}
                        </button>
                      </div>
                    </form>
                  </mat-expansion-panel>
                </mat-accordion>